import MirrorPageEnums from '../enums/mirror-page';
import { HEADER_TITLE } from '../constants/header';

export const isLowerPricePage = (pathname: string) => {
  const lowerPricePages: { [key: string]: boolean } = {
    [MirrorPageEnums.ANTIQUITY_LOWER]: true,
    [MirrorPageEnums.BCP]: true,
    [MirrorPageEnums.YAPE]: true,
    [MirrorPageEnums.LAUNCH]: true,
  };

  return lowerPricePages[pathname] || false;
};

export const isFromChannelPage = (pathname: string) => {
  const channelPage: { [key: string]: boolean } = {
    [MirrorPageEnums.BCP]: true,
    [MirrorPageEnums.YAPE]: true,
  };

  return channelPage[pathname] || false;
};

export const titleBannerPage = (pathname: string) => {
  const titlePage: { [key: string]: string } = {
    [MirrorPageEnums.ANTIQUITY_LOWER]: HEADER_TITLE.lowerPrice,
    [MirrorPageEnums.BCP]: HEADER_TITLE.lowerPrice,
    [MirrorPageEnums.YAPE]: HEADER_TITLE.lowerPrice,
    [MirrorPageEnums.LAUNCH]: HEADER_TITLE.launch,
    [MirrorPageEnums.TAXI]: HEADER_TITLE.taxi,
  };

  return titlePage[pathname] || HEADER_TITLE.normal;
};
